/*
 * Copyright (c) 2021 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';

/**
 * Defines the Design Language Offline Status Icon, represented by a cloud
 * wth a slash (currently used only by smart trailer sensors).
 *
 * ```typescript
 *    import {StatusOfflineCloudIcon} from '@ion/dls/src/icons/';
 *
 *    <StatusOfflineCloudIcon iconColor={iconColor} />
 */
export const StatusOfflineCloudIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize + 4} height={iconSize} viewBox='0 0 16 12' fill='none'>
      <path d='M12.9 4.69341C12.4467 2.39341 10.4267 0.666748 8 0.666748C7.01333 0.666748 6.1 0.953415 5.32667 1.44675L6.3 2.42008C6.80667 2.15341 7.38667 2.00008 8 2.00008C10.0267 2.00008 11.6667 3.64008 11.6667 5.66675V6.00008H12.6667C13.7733 6.00008 14.6667 6.89341 14.6667 8.00008C14.6667 8.75342 14.24 9.40675 13.6267 9.74675L14.5933 10.7134C15.44 10.1067 16 9.12008 16 8.00008C16 6.24008 14.6333 4.81342 12.9 4.69341ZM2 1.51341L3.83333 3.34008C1.70667 3.43341 0 5.18008 0 7.33342C0 9.54008 1.79333 11.3334 4 11.3334H11.82L13.1533 12.6667L14 11.8201L2.84667 0.666748L2 1.51341ZM5.15333 4.66675L10.4867 10.0001H4C2.52667 10.0001 1.33333 8.80675 1.33333 7.33342C1.33333 5.86008 2.52667 4.66675 4 4.66675H5.15333Z'
        fill={iconColor} />
    </svg>
  );
};
